<template>
  <div class="teamWarp" v-if="isMobile!= 0">
    <div class="pc" v-if="isMobile == 1">
      <header-view ref="headers"></header-view>
      <div class="page page-4" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
        <div class="page4Warp">
          <div class="title fAb">
            <div>
              Team
            </div>
            <div class="bak">
              <PcBak :homeIndex="3"></PcBak>
            </div>
          </div>
          <div class="tList">
            <TeamView :teamList="teamList.list"></TeamView>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile pw100" v-else>
      <TeamMobileView :teamList="teamList.list"></TeamMobileView>
    </div>
  </div>
</template>
<script>

import headerView from "@/components/Common/Header.vue";
import TeamView from "@/components/Team/index.vue";
import TeamMobileView from "@/components/Mobile/team.vue";
import PcBak from "@/components/Common/pcBak.vue";

export default {
  components: {PcBak, TeamView, headerView,TeamMobileView},
  data() {
    return {
      headerHeight: 104,
      footerHeight: 20,
      page:1,
      limit:100,
    }
  },
  created() {
    this.$store.dispatch('setPageCurrentIndex', 3)
    this.getList()
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    teamList(){
      return this.$store.getters.teamList
    }
  },
  methods:{
    async getList(){
      let {data} = await this.$api.getData('team/list',{page:this.page,limit:this.limit})
      this.$store.dispatch('setStoreByKeyData',{key:'setTeamList',data:data})
    },
  }
}
</script>

<style scoped lang="scss">
.pc{
  .page-4 {
    height: 100vh;
    background-image: url("../../assets/image/page4_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .page4Warp {
      height: 100%;
      width: 60%;
      box-sizing: border-box;
      padding: 2rem 0 0rem;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      //overflow: hidden;

      .PortfolioMoreBtn {
        display: inline-block;
        padding: .8rem 3rem;
        color: #fff;
        border: .12rem solid #fff;
        font-size: .9rem;
        cursor: pointer;
        margin-top: 2rem;
      }

      .tList {
        flex: 1;
        //overflow: auto;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }

      .title {
        text-align: center;
        margin-bottom: 3rem;
        color: #fff;
        font-size: 1.8rem;
        position: relative;
        width: 100%;
        .bak{
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
        }
      }
    }
  }
}
</style>
